import { defineComponent as _defineComponent } from 'vue'
import WizardStep from '@/components/wizard/WizardStep.vue';
import OtherMembershipsSummarySection from './OtherMembershipsSummarySection.vue';
import { isEmpty, isNil } from '@/utils/misc';
import { User } from '@/models/user';
import { computed, ref } from 'vue';
import { Location } from '@/models/location';
import { locationsService } from '@/services/locations.service';
import { ConsoleEnum } from '@/models/enums/ConsoleEnum';
import moment from 'moment';
import { UserType } from '@/models/userType';
import { useI18n } from '@/composables/i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'SummaryWizardStep',
  props: {
    user: null,
    showSubsidiaryMembership: { type: Boolean, default: false },
    showCustomerMembership: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { user: User, showSubsidiaryMembership: boolean, showCustomerMembership: boolean };



const { t } = useI18n();

const locations = ref<Location[]>([]);
const isLoadingLocations = ref(false);

const DATE_FORMAT = 'D/M/YYYY';

async function onEnter() {
  if (props.showCustomerMembership) {
    await loadLocations();
  }
}

function getFormattedConsoleDateRange(console: ConsoleEnum): string {
  const from = moment(props.user.getConsoleActivationDate(console)).format(
    DATE_FORMAT,
  );
  const toDate = props.user.getConsoleEndDate(console);
  if (isNil(toDate)) {
    return t('wizards.user_creation.summary.console_from', { from }).toString();
  } else {
    const to = moment(toDate).format(DATE_FORMAT);
    return t('wizards.user_creation.summary.console_from_to', {
      from,
      to,
    }).toString();
  }
}

async function loadLocations() {
  isLoadingLocations.value = true;
  try {
    locations.value = await locationsService.get(props.user.customerId);
  } finally {
    isLoadingLocations.value = false;
  }
}

function hasAccessToLocation(id: number) {
  return locations.value.some((x) => x.id === id);
}

function getLocationName(id: number) {
  return locations.value.find((x) => x.id === id)?.name;
}

const allowedLocations = computed(() =>
  props.user.locations.filter((location) => hasAccessToLocation(location)),
);

const consoles = computed(() => {
  if (props.showCustomerMembership) {
    return props.user.consoles;
  }

  switch (props.user.userType) {
    case UserType.TechnologyUser:
      return [ConsoleEnum.Technology];
    case UserType.ServiceGlobal:
    case UserType.ServiceUser:
      return [ConsoleEnum.WCC, ConsoleEnum.Care];
    default:
      return [
        ConsoleEnum.WCC,
        ConsoleEnum.BC,
        ConsoleEnum.SFC,
        ConsoleEnum.Care,
        ConsoleEnum.Technology,
      ];
  }
});

const userHasEnabledWCC = computed(() =>
  props.user.consoles.includes(ConsoleEnum.WCC),
);

return { __sfc: true,props, t, locations, isLoadingLocations, DATE_FORMAT, onEnter, getFormattedConsoleDateRange, loadLocations, hasAccessToLocation, getLocationName, allowedLocations, consoles, userHasEnabledWCC, WizardStep, OtherMembershipsSummarySection, isEmpty }
}

})